import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Observable, forkJoin, of, pipe } from 'rxjs';
import { Albaran } from '../../models/albaran.model';
import { AlbaranService } from '../../services/albaran.service';
import { catchError, mergeMap, take } from 'rxjs/operators';
import { DevolucionService } from '../../services/devolucion.service';
import { Carrito } from 'src/app/modules/venta';
import { Router } from '@angular/router';
import { FormControlService } from 'src/app/shared/services/form-control.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FilterService } from 'src/app/shared/services/filter.service';
import { PagerService } from 'src/app/shared/services/pager.service';
import { PrintService } from 'src/app/shared/services/print.service';
import { FacturaService } from 'src/app/shared/services/factura.service';
import { ConfigurationService, TurnoService } from 'src/app/core';
import { PagoService } from 'src/app/modules/venta/services/pago.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { TranslateService } from '../../../../shared/services/translate.service';
import { DatosAlbaranTicketsProductos } from '../../models/albaran.model';
import { ModalService } from '../../../../shared/services/modal.service';
import { GestorEfectivoService } from 'src/app/core/hardware/gestor-efectivo/gestorEfectivo.service';
import {
  normalizeCashKeeperError,
  CASHKEEPER_ERROR_DEFAULT,
  getErrorMessage,
  extractDescriptionCashKeeper,
} from 'src/app/core/hardware/gestor-efectivo/cashkeeper-codigos';

interface AlbaranDevolucion extends Albaran {
  AlbaranItemsDesglose: any;
}

@Component({
  selector: 'ticketing-selector-devolucion',
  templateUrl: './selector-devolucion.component.html',
  styleUrls: ['./selector-devolucion.component.scss']
})
export class SelectorDevolucionComponent implements OnInit, OnDestroy {
  albaran$: Observable<Albaran>;
  albaran: Albaran;
  carritoDevolucion$: Observable<Carrito>;
  arr = [];
  selectedItems = [];

  @ViewChild('checkAllSwitch', { static: false }) checkAllSwitch: ElementRef;

  items: any[];
  conf: any;
  pager: any = { pages: [], currentPage: 1, totalPages: 0, startIndex: 0, endIndex: 0 };
  pagedItems: any[];
  deshabilitarFiltro: boolean;
  busquedaForm: FormGroup;
  pulsado = false;

  fecha;
  recintos = [];
  recintosIndex = [];
  currentRecinto;
  currentRecintoIndex = 0;
  sesionSeleccionada;
  idioma = 'es-ES';
  listadoSesiones = [];
  sesionesSeleccionadas = [];

  // Resultado de GetDatosAlbaranTicketsProductos (carga inicial y búsquedas)
  datosTicketsProductos: DatosAlbaranTicketsProductos;

  private alive = true;

  franjasHorario = [];

  constructor(
    private albaranService: AlbaranService,
    private devolucionService: DevolucionService,
    private pagerService: PagerService,
    private facturaService: FacturaService,
    private printService: PrintService,
    private formControlService: FormControlService,
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private router: Router,
    private configuration: ConfigurationService,
    private turnoService: TurnoService,
    private toast: ToastrService,
    private pagoService: PagoService,
    private translate: TranslateService,
    private modalService: ModalService,
    private gestorEfectivoService: GestorEfectivoService
  ) {
  }

  ngOnInit() {
    this.conf = this.configuration.appConfig.value;
    this.busquedaForm = this.formBuilder.group({
      query: ''
    });
    this.albaran = this.albaranService.albaranValue;

    // Carga inicial: llamar a GetDatosAlbaranTicketsProductos según US
    // tipoAccion: 1 para listar tickets para la devolución
    const albaranIdOClave = this.albaran?.NumAlbaran || this.albaran?.NumVenta;
    
    if (albaranIdOClave) {
      this.albaranService
        .getDatosAlbaranTicketsProductos(albaranIdOClave, undefined, 1)
        .subscribe((res) => {
          this.datosTicketsProductos = res;
          
          // Generar items usando los datos de GetDatosAlbaranTicketsProductos
          this.generarItemsConDatosActualizados();
        });
    } else {
      // Si no hay albaranIdOClave, usar datos del albarán existente
      this.generarItemsConDatosActualizados();
    }
    // this.arr = this.unbundleItems(this.albaran.AlbaranItems);
  }

  private generarItemsConDatosActualizados() {
    const ticketsSrc = this.datosTicketsProductos?.ListadoAlbaranTicketsProductos || 
                      (this.albaran && this.albaran.AlbaranTicketsDatosImpresion ? this.albaran.AlbaranTicketsDatosImpresion : []);
    const albaranesSrc = JSON.parse(JSON.stringify((this.albaran && this.albaran.AlbaranItems) ? this.albaran.AlbaranItems : [])); // copia profunda
    const motivosSrc = (this.albaran && this.albaran.AlbaranMotivos) ? this.albaran.AlbaranMotivos : [];
    
    
    // CORRECCIÓN: Mantener entradas conjuntas agrupadas como 1-4, 5-7, 8-10
    this.arr = (ticketsSrc as any[]).map(ticket => {
      // Buscar datos de entrada correspondientes
      const datosEntrada = albaranesSrc.find(item => 
        item.ItemId === ticket.ProductoId && item.TipoProducto == ticket.TipoProducto
      );
      
      // Buscar motivo si existe (usar el primer ticket del rango para motivos)
      const primerTicket = ticket.TicketsListado && ticket.TicketsListado.length > 0 ? ticket.TicketsListado[0] : ticket.TicketsGestion;
      const motivo = motivosSrc.find(m => 
        m.NumTicket == primerTicket && m.TipoEntradaId === ticket.ProductoId
      );
      
      let itemInfo = null;
      if (datosEntrada) {
        itemInfo = {
          FechaHoraEntrada: datosEntrada.FechaHoraEntrada,
          NombreTipo: datosEntrada.NombreTipo,
          Fecha: datosEntrada.FechaHoraEntrada,
          id: datosEntrada.ItemId,
          idTarifa: datosEntrada.ItemId,
          GrupoTarifa: datosEntrada.CategoriaId,
          noEditable: false,
          ItemId: datosEntrada.ItemId,
          CategoriaId: +datosEntrada.CategoriaId,
          TipoEntradaId: datosEntrada.ItemId,
          TipoPromocionId: datosEntrada.ItemId,
          TipoAbonadoId: '',
          GrupoId: datosEntrada.GrupoId || '',
          GrupoMotivoId: datosEntrada.GrupoMotivoId || '',
          NombrePantalla: datosEntrada.NombrePantalla,
          NombreImpresion: datosEntrada.NombreImpresion,
          NombreDisplay: datosEntrada.NombreDisplay,
          Minimo: '1',
          Maximo: '999',
          Orden: '1',
          PrecioEnDivisaReferencia: datosEntrada.PrecioUnidad || '0',
          PrecioBase: datosEntrada.PrecioBase || '0',
          IVA: datosEntrada.IVA || '0',
          Comision: datosEntrada.Comision || '0',
          IvaComision: datosEntrada.IvaComision || '0',
          ComisionBase: datosEntrada.ComisionBase || '0',
          DesglosarComision: datosEntrada.DesglosarComision || '0',
          recintos: [],
          motivos: [],
          extraData: {},
          auditorio: false,
          fechaAuditorio: '',
          horaAuditorio: '',
          idRecintoButaca: '',
          PromocionEntradas: datosEntrada.PromocionEntradas || [],
          TipoProducto: datosEntrada.TipoProducto,
          CaracteristicasEntrada: [],
          Cantidad: datosEntrada.Cantidad || '1',
          ImporteTicket: ticket.ImporteTicket || 0,
          BarCode: null,
          itemInfo: null,
          Hora: null,
          PrecioUnidad: datosEntrada.PrecioUnidad,
          EspectaculosImprimir: null,
          PosicionesVenta: datosEntrada.PosicionesVenta || [],
          CuentaVisitante: datosEntrada.CuentaVisitante || '',
          FarId: [],
          ImprimirTicket: '1',
          ListaButacas: [],
          Modificado: false,
          NumOrdenPromos: datosEntrada.NumOrdenPromos || [],
          NumOrdenPromosConEntradas: [],
          cantidad: datosEntrada.Cantidad || '1',
          PrecioTotal: datosEntrada.PrecioTotal || '0',
          ControlAforoExterno: datosEntrada.ControlAforoExterno || '0',
          FechaHoraAccesoLocalizadorButaca: '',
          DNIAbonadosExt: datosEntrada.DNIAbonadoExt || '',
          desdeAsociado: false,
          codigoAsociado: '',
          ImporteDto: datosEntrada.ImporteDto || '0',
          PrecioBaseConDto: datosEntrada.PrecioBaseConDto || datosEntrada.PrecioBase || '0'
        };
      }
      
      return {
        ...ticket, // Mantener todas las propiedades del API incluyendo TicketsRango y TicketsListado
        yaDevuelto: ticket.Devuelta === '0' ? false : true,
        id: +ticket.TicketsGestion, // Usar el primer ticket del grupo como ID
        numTickets: ticket.TicketsRango, // Mostrar el rango completo (1-4, 5-7, 8-10)
        itemInfo: itemInfo,
        descMotivo: motivo ? motivo.ItemNombre : '',
        // CORRECCIÓN: Agregar propiedad tickets que espera generarEntradasDevolucion
        tickets: ticket.TicketsListado && ticket.TicketsListado.length > 0 
          ? ticket.TicketsListado.map(ticketNum => ({
              ItemId: ticket.ProductoId,
              OrdenCjta: '0',
              CodigoTipoControl: '',
              BarCode: '',
              EspectaculosImprimir: null
            }))
          : [{
              ItemId: ticket.ProductoId,
              OrdenCjta: '0',
              CodigoTipoControl: '',
              BarCode: '',
              EspectaculosImprimir: null
            }]
      };
    });
    
    // YA NO DEBERÁ AGRUPAR las promociones, tendrá que listar los mismos registros que devuelva el método
    // Se elimina la agrupación de promociones según US
    
    // Configurar búsqueda
    this.configurarBusqueda();
  }

  /**
   * Agrupa los items promocionales (TipoProducto === '2') por ProductoId.
   * Solo afecta a promociones, los productos individuales se mantienen sin cambios.
   * 
   * @param items Array de items procesados del map
   * @returns Array con promociones agrupadas y productos individuales sin cambios
   */
  private agruparPromocionesParaDevolucion(items: any[]): any[] {
    // Separar promociones de productos individuales
    const promociones: any[] = [];
    const productosIndividuales: any[] = [];
    
    items.forEach(item => {
      if (item.itemInfo && item.itemInfo.TipoProducto === '2') {
        promociones.push(item);
      } else {
        productosIndividuales.push(item);
      }
    });
    
    if (promociones.length === 0) {
      return items;
    }
    
    // Agrupar promociones por ProductoId
    const promocionesAgrupadas = this.groupBy(promociones, item => {
      // Usar ProductoId del itemInfo para agrupar
      return item.itemInfo?.ItemId || item.ProductoId || 'unknown';
    });
    
    // Crear items agrupados para cada promoción
    const resultado: any[] = [...productosIndividuales];
    
    for (const [productoId, grupo] of Object.entries(promocionesAgrupadas)) {
      const grupoArray = grupo as any[];
      
      if (grupoArray.length === 0) continue;
      
      const primerItem = grupoArray[0];
      
      // CORRECCIÓN: Para promociones, usar Cantidad del AlbaranItems (siempre 1) y PrecioUnidad
      const cantidadPromocion = parseInt(primerItem.itemInfo.Cantidad) || 1; // Cantidad del AlbaranItems
      const precioUnidad = parseFloat(primerItem.itemInfo.PrecioUnidad.replace(',', '.'));
      const totalImporte = precioUnidad * cantidadPromocion;
      
      // CORRECCIÓN: Redondear valores muy cercanos a números enteros (ej: 19,9998 → 20)
      const totalImporteRedondeado = this.redondearValorCercanoAEntero(totalImporte);
      
      const yaDevuelto = grupoArray.some(item => item.yaDevuelto);
      
      // Obtener todos los TicketsGestion y TicketsListado de los items agrupados
      const todosLosTicketsGestion = grupoArray.map(item => item.TicketsGestion).filter(Boolean);
      const todosLosTicketsListado: string[] = [];
      
      grupoArray.forEach(item => {
        if (item.TicketsListado && Array.isArray(item.TicketsListado)) {
          todosLosTicketsListado.push(...item.TicketsListado);
        } else if (item.TicketsGestion) {
          todosLosTicketsListado.push(item.TicketsGestion);
        }
      });
      
      // Crear item agrupado
      const promocionAgrupada: any = {
        ...primerItem,
        // ID único para la promoción
        id: productoId,
        // Rango de tickets: todos los TicketsGestion separados por comas
        numTickets: todosLosTicketsGestion.join(', '),
        // Mantener todos los tickets originales
        tickets: grupoArray.reduce((acc, item) => {
          if (item.tickets && Array.isArray(item.tickets)) {
            return [...acc, ...item.tickets];
          }
          return acc;
        }, []),
        yaDevuelto: yaDevuelto,
        // Actualizar itemInfo con totales correctos
        itemInfo: {
          ...primerItem.itemInfo,
          Cantidad: cantidadPromocion.toString(), // Usar Cantidad del AlbaranItems (1)
          PrecioTotal: totalImporteRedondeado.toFixed(2).replace('.', ','),
          // CORRECCIÓN: Usar PrecioUnidad original del AlbaranItems para promociones
          PrecioEnDivisaReferencia: primerItem.itemInfo.PrecioUnidad || primerItem.itemInfo.PrecioEnDivisaReferencia,
          // Mantener PrecioUnidad original para el cálculo correcto
          PrecioUnidad: primerItem.itemInfo.PrecioUnidad
        },
        // Mantener TicketsListado con todos los tickets de la promoción
        TicketsListado: todosLosTicketsListado.filter((v, i, a) => a.indexOf(v) === i), // eliminar duplicados
        TicketsGestion: todosLosTicketsGestion.join(', '),
        TicketsRango: todosLosTicketsGestion.length > 1 
          ? `${todosLosTicketsGestion[0]}-${todosLosTicketsGestion[todosLosTicketsGestion.length - 1]}`
          : todosLosTicketsGestion[0] || '',
        // Importe total de la promoción (redondeado)
        ImporteTicket: totalImporteRedondeado,
        // Mantener ProductoId original
        ProductoId: productoId
      };
      
      resultado.push(promocionAgrupada);
    }
    
    return resultado;
  }

  /**
   * Redondea valores muy cercanos a números enteros para mejorar la presentación.
   * Ejemplos: 19,9998 → 20, 15,0001 → 15, 12,5 → 12,5
   * 
   * @param valor Valor a redondear
   * @returns Valor redondeado si está muy cerca de un entero, sino el valor original
   */
  private redondearValorCercanoAEntero(valor: number): number {
    const tolerancia = 0.01; // Tolerancia de 1 céntimo
    const enteroMasCercano = Math.round(valor);
    const diferencia = Math.abs(valor - enteroMasCercano);
    
    if (diferencia <= tolerancia) {
      return enteroMasCercano;
    }
    
    return valor;
  }

  private configurarBusqueda() {
    const listaCompleta = this.arr;
    this.busquedaForm.valueChanges.subscribe(val => {
      this.albaran.AlbaranRecintos.forEach(itemRecinto => {
        if (itemRecinto.Periodo && itemRecinto.Periodo == '1') {
          const recintoInfo = { recintoId: itemRecinto.RecintoId, recintoNombre: itemRecinto.RecintoNombre };
          if (!this.recintosIndex.includes(itemRecinto.RecintoId)) {
            this.recintosIndex.push(
              itemRecinto.RecintoId);
          }
          this.recintos.push(
            recintoInfo);
        }
      });

      this.albaran.AlbaranRecintos.forEach(itemRecinto => {
        if (itemRecinto.Periodo && itemRecinto.Periodo == '1') {
          if (!this.listadoSesiones.includes(itemRecinto.FechaEntrada)) {
            this.listadoSesiones.push(
              itemRecinto.FechaEntrada);
          }
        }
      });
      // 
      // 
      // 
      if (val.query === '') {
        this.arr = listaCompleta;
      } else {
        
        // CORRECCIÓN: Filtrar entradas conjuntas correctamente
        this.arr = [];
        listaCompleta.forEach(item => {
          let querySplit = val.query.split(',');
          querySplit.forEach(queryElement => {
            const queryNum = queryElement.trim();
            
            // Buscar en TicketsGestion (primer ticket del grupo)
            if (queryNum === item.TicketsGestion.toString()) {
              this.arr.push(item);
            }
            // Buscar en TicketsListado si existe (tickets individuales del grupo)
            else if (item.TicketsListado && Array.isArray(item.TicketsListado) && item.TicketsListado.includes(queryNum)) {
              this.arr.push(item);
            }
          });
        });
        
      }
      this.setPage(1);
    });
    this.setPage(1);
    this.carritoDevolucion$ = this.devolucionService.carritoDevolucion$;
    // 
    this.albaranService.anulacionTotal.subscribe(data => {
      if (data) {
        this.deshabilitarFiltro = data;
        this.selectAll();
      } else {
        this.deshabilitarFiltro = data;
        this.unselectAll();
      }
    });
  }


  checkEntrada(event, ticket) {
    const target = event.target as HTMLInputElement;
    
    if (target.checked) {
      this.selectedItems.push(ticket);
      this.devolucionService.setItemsSeleccionados(this.selectedItems);
      this.agregarEntradaAgrupada(ticket);
    } else {
      this.eliminarEntradaAgrupada(ticket);
      this.selectedItems = this.selectedItems.filter(e => e.id !== ticket.id);
      this.devolucionService.setItemsSeleccionados(this.selectedItems);
    }
    
    if (
      this.selectedItems.length ===
      this.arr.filter(e => e.Devuelta !== '1').length
    ) {
      this.checkAllSwitch.nativeElement['checked'] = true;
    } else {
      this.checkAllSwitch.nativeElement['checked'] = false;
    }
    if (this.selectedItems.length === 0) {
      this.checkAllSwitch.nativeElement['checked'] = false;
    }
  }
  
  private agregarEntradaAgrupada(ticket) {
    const key = `${ticket.itemInfo?.TipoProducto}-${ticket.itemInfo?.ItemId}`;
    
    const entradaExistente = this.devolucionService.carritoDevolucion.entradas.find(
      e => `${e.entrada.TipoProducto}-${e.entrada.ItemId}` === key
    );
    
    const esConjunta = this.esEntradaConjunta(ticket);
    const esPromocion = ticket.itemInfo?.TipoProducto === '2';
    
    if (entradaExistente) {
      if (esPromocion) {
        // CORRECCIÓN: Para promociones, cada selección es una promoción (cantidad 1)
        // El ImporteTicket del API ya representa el precio total de esa promoción específica
        entradaExistente.cantidad += 1;
      } else if (esConjunta) {
        const cantidadAAgregar = parseInt(ticket.itemInfo?.Cantidad || '1');
        entradaExistente.cantidad += cantidadAAgregar;
      } else {
        entradaExistente.cantidad += 1;
      }
    } else {
      const entradaParaAgregar = JSON.parse(JSON.stringify(ticket.itemInfo));
      
      if (esPromocion) {
        // CORRECCIÓN: Para promociones, siempre usar cantidad 1 (una promoción)
        entradaParaAgregar.Cantidad = '1';
        // CORRECCIÓN: Usar ImporteTicket como precio si está disponible
        // El ImporteTicket del API ya representa el precio total de esa promoción específica
        if (ticket.ImporteTicket !== undefined && ticket.ImporteTicket > 0) {
          entradaParaAgregar.PrecioUnidad = ticket.ImporteTicket.toString();
          entradaParaAgregar.PrecioEnDivisaReferencia = ticket.ImporteTicket.toString();
          entradaParaAgregar.ImporteTicket = ticket.ImporteTicket;
        }
      } else if (esConjunta) {
        // Mantener cantidad original para entradas conjuntas que no son promociones
      } else {
        entradaParaAgregar.Cantidad = '1';
      }
      
      this.devolucionService.carritoDevolucion.agregarEntrada(
        entradaParaAgregar, 
        true
      );
    }
    
    this.devolucionService.carritoDevolucion.recalcularTotales();
  }
  
  private eliminarEntradaAgrupada(ticket) {
    const key = `${ticket.itemInfo?.TipoProducto}-${ticket.itemInfo?.ItemId}`;
    
    const entradaExistente = this.devolucionService.carritoDevolucion.entradas.find(
      e => `${e.entrada.TipoProducto}-${e.entrada.ItemId}` === key
    );
    
    if (entradaExistente) {
      const esPromocion = ticket.itemInfo?.TipoProducto === '2';
      
      if (esPromocion) {
        // CORRECCIÓN: Para promociones, cada eliminación es una promoción (cantidad 1)
        if (entradaExistente.cantidad > 1) {
          entradaExistente.cantidad -= 1;
        } else {
          const entradaParaEliminar = JSON.parse(JSON.stringify(ticket.itemInfo));
          entradaParaEliminar.Cantidad = '1';
          this.devolucionService.carritoDevolucion.eliminarEntrada(
            entradaParaEliminar, 
            true
          );
        }
      } else if (this.esEntradaConjunta(ticket)) {
        const cantidadAEliminar = parseInt(ticket.itemInfo?.Cantidad || '1');
        if (entradaExistente.cantidad > cantidadAEliminar) {
          entradaExistente.cantidad -= cantidadAEliminar;
        } else {
          const entradaParaEliminar = JSON.parse(JSON.stringify(ticket.itemInfo));
          this.devolucionService.carritoDevolucion.eliminarEntrada(
            entradaParaEliminar, 
            true
          );
        }
      } else {
        if (entradaExistente.cantidad > 1) {
          entradaExistente.cantidad -= 1;
        } else {
          const entradaIndividual = JSON.parse(JSON.stringify(ticket.itemInfo));
          entradaIndividual.Cantidad = '1';
          this.devolucionService.carritoDevolucion.eliminarEntrada(
            entradaIndividual, 
            true
          );
        }
      }
    }
    
    this.devolucionService.carritoDevolucion.recalcularTotales();
  }

  /**
   * Determina si una entrada es conjunta (promoción o grupo) o individual
   * @param ticket - El ticket a evaluar
   * @returns true si es entrada conjunta, false si es individual
   */
  private esEntradaConjunta(ticket): boolean {
    const itemInfo = ticket.itemInfo;
    
    // Es promoción (TipoProducto === '2')
    if (itemInfo?.TipoProducto === '2') {
      return true;
    }
    
    // Tiene orden conjunta
    if (ticket.OrdenCjta && parseInt(ticket.OrdenCjta) > 0) {
      return true;
    }
    
    // Tiene PromocionEntradas (es una promoción real)
    if (itemInfo?.PromocionEntradas && itemInfo.PromocionEntradas.length > 0) {
      return true;
    }
    
    // CORRECCIÓN: Es entrada agrupada si numTickets contiene rango (ej: "1-3")
    if (ticket.numTickets && ticket.numTickets.includes('-')) {
      return true;
    }
    
    // Es una entrada individual duplicada (Cantidad > 1 pero no es promoción ni agrupada)
    return false;
  }

  isChecked(ticket) {
    return this.selectedItems.find(e => e.id === ticket.id);
  }

  checkAllEntradas(event) {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      this.selectAll();
    } else {
      this.unselectAll();
    }
  }

  private selectAll() {
    // CORRECCIÓN: Limpiar el carrito antes de agregar nuevas entradas para evitar duplicados
    this.devolucionService.setCarritoDevolucion(new Carrito());
    this.selectedItems = [];
    
    // CORRECCIÓN: Replicar exactamente la lógica de selección manual
    // Iterar sobre todas las entradas y agregarlas una por una, como si el usuario
    // hubiera hecho click en cada checkbox individualmente
    this.arr.forEach((e, index) => {
      const estaSeleccionada = this.isChecked(e);
      const estaDevuelta = e.yaDevuelto;
      
      if (!estaSeleccionada && !estaDevuelta) {
        // Agregar a selectedItems (igual que en checkEntrada cuando está checked)
        this.selectedItems.push(e);
        
        // Llamar a agregarEntradaAgrupada (igual que en checkEntrada cuando está checked)
        // Esta función maneja correctamente promociones, entradas conjuntas, ImporteTicket, etc.
        this.agregarEntradaAgrupada(e);
      }
    });
    
    // Actualizar el servicio con los items seleccionados (igual que en checkEntrada)
    this.devolucionService.setItemsSeleccionados(this.selectedItems);
    
    // Marcar el checkbox "DEVOLVER TODAS" como checked
    if (this.checkAllSwitch) {
      this.checkAllSwitch.nativeElement['checked'] = true;
    }
  }

  private unselectAll() {

    this.selectedItems = [];
    this.devolucionService.setItemsSeleccionados(this.selectedItems);
    this.devolucionService.setCarritoDevolucion(new Carrito());
  }

//<< Yaribel 20210224  modificamos el generateItems  para que tenga en cuenta orden conjunta y  y Qr Promo
  // private generateItems(tickets, albaranes, motivos?) {

  //   const ticketsAgrupados = this.groupBy(tickets, c =>
  //     c.NumOrdenPromo !== '' ? c.NumOrdenPromo : c.RegistroTablaId
  //   );

  //   
  //   
  //   

  //   const respuesta = [];
  //   const numOrdenPromoId = [];
  //   try {
  //   for (const [key, ticket] of Object.entries(ticketsAgrupados)) {
  //     
  //     
  //     if (Object.entries(ticket).length > 1) {
  //       let contador = 0;
  //       while (contador < Object.entries(ticket).length)  {
  //         

  //         if (ticket[contador].TipoProducto === '1') {
  //           const datosEntrada = albaranes.find(i => {
  //             return i.ItemId === ticket[contador].ItemId && i.TipoProducto == 1;
  //           });
  //           
  //           if (datosEntrada){
  //           datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
  //           datosEntrada.idTarifa = datosEntrada.ItemId;
  //           datosEntrada.TipoEntradaId = datosEntrada.ItemId;
  //           let txtMotivo:string = motivos && motivos.length >0 && motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId)?
  //                                  motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId).ItemNombre:"";
  //           const yaDevuelto = ticket[contador].Devuelta === '0' ? false : true;
  //           respuesta.push({
  //             tickets: ticket,
  //             yaDevuelto: yaDevuelto,
  //             id: +ticket[contador].NumTicket,
  //             numTickets: +ticket[contador].NumTicket,
  //             itemInfo: datosEntrada,
  //             descMotivo: txtMotivo
  //           });
  //         }
  //         } else if (ticket[contador].TipoProducto === '2') {
  //           
  //           
  //           if (!numOrdenPromoId.includes(ticket[contador].NumOrdenPromo)) {
  //             const datosEntrada = albaranes.find(item => {
  //                return item.ItemId === ticket[contador].TipoPromocionId && item.TipoProducto == 2;  
  //             });
  //             
  //             if (datosEntrada){
  //             datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
  //             datosEntrada.idTarifa = datosEntrada.ItemId;
  //             datosEntrada.TipoPromocionId = datosEntrada.ItemId;
  //             const yaDevuelto = ticket[contador].Devuelta === '0' ? false : true;
  //             
  //             
  //             numOrdenPromoId.push(ticket[contador].NumOrdenPromo);
  //             const promocionEntradas = [];
  //             let contadorPromo = 0;
  //             datosEntrada.PromocionEntradas.forEach(entrada => {
  //               //
  //               //
  //               if (contadorPromo >= Object.entries(ticket).length) {
  //                 contadorPromo = 0;
  //               }
  //               if (entrada.NumOrdenPromo == ticket[contador].NumOrdenPromo) {
  //                 const tempObject = Object.assign({}, entrada, {
  //                   NumOrdenPromo: ticket[contador].NumOrdenPromo,
  //                   NumeroEntradas: ticket[contadorPromo].NumTicket
  //                 });
  //                 promocionEntradas.push(tempObject);
  //               }
  //               contadorPromo++;
  //             });
  //             
  //             const temp = Object.assign({}, datosEntrada, {
  //               PromocionEntradas: promocionEntradas
  //             });
  //             let numTickets = '';
  //             for (const [k, item] of Object.entries(ticket)) {
  //               numTickets = '' + numTickets + ', ' + item.NumTicket;
  //             }
  //             numTickets = numTickets.substr(1);
  //             
  //             let txtMotivo:string = motivos && motivos.length >0 && motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === ticket[contador].ItemId)?
  //                                    motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === ticket[contador].ItemId).ItemNombre:"";
  //             respuesta.push({
  //               tickets: ticket,
  //               yaDevuelto: yaDevuelto,
  //               id: +ticket[contador].NumTicket,
  //               numTickets: numTickets,
  //               itemInfo: temp,
  //               descMotivo: txtMotivo
  //             });
  //           }
  //           }
  //         }
  //         contador ++;
  //       }
  //     } else {
  //       if (ticket[0].TipoProducto === '1') {
  //         const datosEntrada = albaranes.find(i => {
  //           return i.ItemId === ticket[0].ItemId && i.TipoProducto == 1;
  //         });
  //         
  //         if (datosEntrada){
  //         datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
  //         datosEntrada.idTarifa = datosEntrada.ItemId;
  //         datosEntrada.TipoEntradaId = datosEntrada.ItemId;
  //         const yaDevuelto = ticket[0].Devuelta === '0' ? false : true;
  //         let txtMotivo:string = motivos && motivos.length >0 && motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId)?
  //                                motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId).ItemNombre:"";
  //         respuesta.push({
  //           tickets: ticket,
  //           yaDevuelto: yaDevuelto,
  //           id: +ticket[0].NumTicket,
  //           numTickets: +ticket[0].NumTicket,
  //           itemInfo: datosEntrada,
  //           descMotivo: txtMotivo
  //         });
  //       }
  //       } else if (ticket[0].TipoProducto === '2') {
  //         
  //         
  //         if (!numOrdenPromoId.includes(ticket[0].NumOrdenPromo)) {
  //           const datosEntrada = albaranes.find(item => {
  //             //return item.ItemId === ticket[0].ItemId && item.TipoProducto == 2;
  //             return item.ItemId === ticket[0].TipoPromocionId && item.TipoProducto == 2; //Yaribel 20201127 Cambiamos esto para que evalue por item
  //           });
  //           
  //           if (datosEntrada){
  //           datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
  //           datosEntrada.idTarifa = datosEntrada.ItemId;
  //           datosEntrada.TipoPromocionId = datosEntrada.ItemId;
  //           const yaDevuelto = ticket[0].Devuelta === '0' ? false : true;
  //           
  //           
  //           numOrdenPromoId.push(ticket[0].NumOrdenPromo);
  //           const promocionEntradas = [];
  //           datosEntrada.PromocionEntradas.forEach(entrada => {
  //             const tempObject = Object.assign({}, entrada, {
  //               NumOrdenPromo: ticket[0].NumOrdenPromo,
  //               NumeroEntradas: ticket[0].NumTicket
  //             });
  //             promocionEntradas.push(tempObject);
  //           });
  //           
  //           const temp = Object.assign({}, datosEntrada, {
  //             PromocionEntradas: promocionEntradas
  //           });
  //           let numTickets = '';
  //           for (const [k, item] of Object.entries(ticket)) {
  //             numTickets = '' + numTickets + ', ' + item.NumTicket;
  //           }
  //           numTickets = numTickets.substr(1);
  //           
  //           let txtMotivo:string = motivos && motivos.length >0 && motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === ticket[0].ItemId)?
  //                                  motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === ticket[0].ItemId).ItemNombre:"";
  //           respuesta.push({
  //             tickets: ticket,
  //             yaDevuelto: yaDevuelto,
  //             id: +ticket[0].NumTicket,
  //             numTickets: numTickets,
  //             itemInfo: temp,
  //             descMotivo: txtMotivo
  //           });
  //         }
  //         }
  //       }
  //     }
  //   }

  //   
  // }catch(e){
  //   console.error(e);
  //   this.toast.error('Ocurrió un error inesperado', 'Error', {
  //     toastComponent: ErrorToast
  //   });
  // } finally{
  //   return respuesta;
  // }

  // }

  private generateItems(tickets, albaranes, motivos?) {
    const ticketsAgrupados = this.groupBy(tickets, c =>
      c.NumOrdenPromo && c.NumOrdenPromo !== '' ? c.NumOrdenPromo : c.ProductoId
    );

    // 
    // 
    // 

    const respuesta = [];
    const numOrdenPromoId = [];
    try {
      for (const [key, ticket] of Object.entries(ticketsAgrupados)) {
        //
        //
        // if(Object.entries(ticket).length > 0)
        // {
        //   let contador = 0;
        //   while (contador < Object.entries(ticket).length)  {
        //
        //     if (ticket[contador].TipoProducto === '1') {
        //       const datosEntrada = albaranes.find(i => {
        //         return i.ItemId === ticket[contador].ItemId && i.TipoProducto == 1;
        //       });
        //
        //       if (datosEntrada){
        //       datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
        //       datosEntrada.idTarifa = datosEntrada.ItemId;
        //       datosEntrada.TipoEntradaId = datosEntrada.ItemId;
        //       let txtMotivo:string = motivos && motivos.length >0 && motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId)?
        //                              motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId).ItemNombre:"";
        //       const yaDevuelto = ticket[contador].Devuelta === '0' ? false : true;
        //       respuesta.push({
        //         tickets: ticket,
        //         yaDevuelto: yaDevuelto,
        //         id: +ticket[contador].NumTicket,
        //         numTickets: +ticket[contador].NumTicket,
        //         itemInfo: datosEntrada,
        //         descMotivo: txtMotivo
        //       });
        //     }
        //     } else if (ticket[contador].TipoProducto === '2') {
        //
        //
        //       if (!numOrdenPromoId.includes(ticket[contador].NumOrdenPromo)) {
        //         const datosEntrada = albaranes.find(item => {
        //            return item.ItemId === ticket[contador].TipoPromocionId && item.TipoProducto == 2;
        //         });
        //
        //         if (datosEntrada){
        //         datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
        //         datosEntrada.idTarifa = datosEntrada.ItemId;
        //         datosEntrada.TipoPromocionId = datosEntrada.ItemId;
        //         const yaDevuelto = ticket[contador].Devuelta === '0' ? false : true;
        //
        //
        //         numOrdenPromoId.push(ticket[contador].NumOrdenPromo);
        //         const promocionEntradas = [];
        //         let contadorPromo = 0;
        //         datosEntrada.PromocionEntradas.forEach(entrada => {
        //           //
        //           //
        //           if (contadorPromo >= Object.entries(ticket).length) {
        //             contadorPromo = 0;
        //           }
        //           if (entrada.NumOrdenPromo == ticket[contador].NumOrdenPromo) {
        //             const tempObject = Object.assign({}, entrada, {
        //               NumOrdenPromo: ticket[contador].NumOrdenPromo,
        //               NumeroEntradas: ticket[contadorPromo].NumTicket
        //             });
        //             promocionEntradas.push(tempObject);
        //           }
        //           contadorPromo++;
        //         });
        //
        //         const temp = Object.assign({}, datosEntrada, {
        //           PromocionEntradas: promocionEntradas
        //         });
        //         let numTickets = '';
        //         for (const [k, item] of Object.entries(ticket)) {
        //           numTickets = '' + numTickets + ', ' + item.NumTicket;
        //         }
        //         numTickets = numTickets.substr(1);
        //
        //         let txtMotivo:string = motivos && motivos.length >0 && motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === ticket[contador].ItemId)?
        //                                motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === ticket[contador].ItemId).ItemNombre:"";
        //         respuesta.push({
        //           tickets: ticket,
        //           yaDevuelto: yaDevuelto,
        //           id: +ticket[contador].NumTicket,
        //           numTickets: numTickets,
        //           itemInfo: temp,
        //           descMotivo: txtMotivo
        //         });
        //       }
        //       }
        //     }
        //     contador ++;
        //   }

        // }

        
        if (Object.entries(ticket).length > 1) {
          let contador = 0;
          
          while (contador < Object.entries(ticket).length) {
            if (ticket[contador].TipoProducto === '1') {
              const datosEntrada = albaranes.find(i => {
                return i.ItemId === ticket[contador].ProductoId && i.TipoProducto == 1;
              });
              //
              if (datosEntrada) {
                datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
                datosEntrada.idTarifa = datosEntrada.ItemId;
                datosEntrada.TipoEntradaId = datosEntrada.ItemId;
                let txtMotivo: string = motivos && motivos.length > 0 && motivos.find(x => x.NumTicket == ticket[contador].TicketsGestion && x.TipoEntradaId === datosEntrada.TipoEntradaId) ?
                  motivos.find(x => x.NumTicket == ticket[contador].TicketsGestion && x.TipoEntradaId === datosEntrada.TipoEntradaId).ItemNombre : '';
                const yaDevuelto = ticket[contador].Devuelta === '0' ? false : true;
                // Calcular cantidad basada en TicketsListado si existe, sino usar 1
                const cantidadTickets = ticket[contador].TicketsListado && ticket[contador].TicketsListado.length > 0 
                  ? ticket[contador].TicketsListado.length 
                  : (ticket[contador].Cantidad || 1);
                datosEntrada.Cantidad = cantidadTickets;
                
                
                respuesta.push({
                  tickets: ticket,
                  yaDevuelto: yaDevuelto,
                  id: +ticket[contador].TicketsGestion,
                  numTickets: +ticket[contador].TicketsGestion,
                  itemInfo: datosEntrada,
                  descMotivo: txtMotivo
                });
              } else {
              }
            } else if (ticket[contador].TipoProducto === '2') {
              if (!numOrdenPromoId.includes(ticket[contador].NumOrdenPromo)) {
                const datosEntrada = albaranes.find(item => {
                  return item.ItemId === ticket[contador].TipoPromocionId && item.TipoProducto == 2;
                });
                
                if (datosEntrada) {
                  const precioTotalPromocion = Number.parseFloat(datosEntrada.PrecioTotal.toString().replace(/,/, '.'));
                  const cantidadTotalEntradas = datosEntrada.Cantidad || 1;
                  const precioPorEntrada = precioTotalPromocion / cantidadTotalEntradas;
                  
                  datosEntrada.PrecioEnDivisaReferencia = precioPorEntrada.toString();
                  
                  datosEntrada.idTarifa = datosEntrada.ItemId;
                  
                  const ticketOriginal = tickets.find(t => t.TicketsGestion === ticket[contador].TicketsGestion);
                  
                  if (ticketOriginal && ticketOriginal.ImporteTicket !== undefined) {
                    datosEntrada.ImporteTicket = ticketOriginal.ImporteTicket;
                  }
                  datosEntrada.TipoPromocionId = datosEntrada.ItemId;
                  const yaDevuelto = ticket[contador].Devuelta === '0' ? false : true;
                  // Calcular cantidad basada en TicketsListado si existe, sino usar 1
                  const cantidadTickets = ticket[contador].TicketsListado && ticket[contador].TicketsListado.length > 0 
                    ? ticket[contador].TicketsListado.length 
                    : (ticket[contador].Cantidad || 1);
                  datosEntrada.Cantidad = cantidadTickets;
                  
                  
                  //
                  //
                  numOrdenPromoId.push(ticket[contador].NumOrdenPromo);
                  const promocionEntradas = [];
                  let contadorPromo = 0;
                  datosEntrada.PromocionEntradas.forEach(entrada => {
                    if (contadorPromo >= Object.entries(ticket).length) {
                      contadorPromo = 0;
                    }
                    //<< Yaribel 20210224 Añadimos comprobacion de orden conjunta o QRPromo
                    const tempObject = Object.assign({}, entrada, {
                      NumOrdenPromo: +ticket[0].OrdenCjta > 0 ? entrada.NumOrdenPromo : ticket[contador].NumOrdenPromo,
                      NumeroEntradas: ticket[contadorPromo].NumTicket
                    });
                    if (ticket[0].OrdenCjta == '0') {
                      if (entrada.NumOrdenPromo == ticket[contador].NumOrdenPromo) {
                        promocionEntradas.push(tempObject);
                      }
                    } else {
                      promocionEntradas.push(tempObject);
                    }
                    // Yaribel 20210224 >>
                    contadorPromo++;
                  });
                  //
                  const temp = Object.assign({}, datosEntrada, {
                    PromocionEntradas: promocionEntradas
                  });
                  let numTickets = '';
                  for (const [k, item] of Object.entries(ticket)) {
                    numTickets = '' + numTickets + ', ' + item.NumTicket;
                  }
                  numTickets = numTickets.substr(1);
                  //
                  let txtMotivo: string = motivos && motivos.length > 0 && motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === ticket[contador].ItemId) ?
                    motivos.find(x => x.NumTicket == ticket[contador].NumTicket && x.TipoEntradaId === ticket[contador].ItemId).ItemNombre : '';
                  respuesta.push({
                    tickets: ticket,
                    yaDevuelto: yaDevuelto,
                    id: +ticket[contador].NumTicket,
                    numTickets: numTickets,
                    itemInfo: datosEntrada,
                    descMotivo: txtMotivo
                  });
                }
              }
            }
            contador++;
          }
        } else {
          
          if (ticket[0].TipoProducto === '1') {
            const datosEntrada = albaranes.find(i => {
              return i.ItemId === ticket[0].ProductoId && i.TipoProducto == 1;
            });
            //
            if (datosEntrada) {
              datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
              datosEntrada.idTarifa = datosEntrada.ItemId;
              datosEntrada.TipoEntradaId = datosEntrada.ItemId;
              const yaDevuelto = ticket[0].Devuelta === '0' ? false : true;
              // Calcular cantidad basada en TicketsListado si existe, sino usar 1
              const cantidadTickets = ticket[0].TicketsListado && ticket[0].TicketsListado.length > 0 
                ? ticket[0].TicketsListado.length 
                : (ticket[0].Cantidad || 1);
              datosEntrada.Cantidad = cantidadTickets;
              let txtMotivo: string = motivos && motivos.length > 0 && motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId) ?
                motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === datosEntrada.TipoEntradaId).ItemNombre : '';
              
              
              respuesta.push({
                tickets: ticket,
                yaDevuelto: yaDevuelto,
                id: +ticket[0].TicketsGestion,
                numTickets: +ticket[0].TicketsGestion,
                itemInfo: datosEntrada,
                descMotivo: txtMotivo
              });
            } else {
            }
          } else if (ticket[0].TipoProducto === '2') {
            //

            if (!numOrdenPromoId.includes(ticket[0].NumOrdenPromo)) {
              const datosEntrada = albaranes.find(item => {
                //return item.ItemId === ticket[0].ItemId && item.TipoProducto == 2;
                return item.ItemId === ticket[0].TipoPromocionId && item.TipoProducto == 2; //Yaribel 20201127 Cambiamos esto para que evalue por item
              });
              //
              if (datosEntrada) {
                datosEntrada.PrecioEnDivisaReferencia = datosEntrada.PrecioUnidad;
                datosEntrada.idTarifa = datosEntrada.ItemId;
                datosEntrada.TipoPromocionId = datosEntrada.ItemId;
                const yaDevuelto = ticket[0].Devuelta === '0' ? false : true;
                // Calcular cantidad basada en TicketsListado si existe, sino usar 1
                const cantidadTickets = ticket[0].TicketsListado && ticket[0].TicketsListado.length > 0 
                  ? ticket[0].TicketsListado.length 
                  : (ticket[0].Cantidad || 1);
                datosEntrada.Cantidad = cantidadTickets;
                
                
                //
                //
                numOrdenPromoId.push(ticket[0].NumOrdenPromo);
                const promocionEntradas = [];
                datosEntrada.PromocionEntradas.forEach(entrada => {
                  //<<Yaribel 20210224 Añadimos comprobacion de orden conjunta o QRPromo
                  // const tempObject = Object.assign({}, entrada, {
                  //   NumOrdenPromo: ticket[0].NumOrdenPromo,
                  //   NumeroEntradas: ticket[0].NumTicket
                  // });
                  // promocionEntradas.push(tempObject);
                  const tempObject = Object.assign({}, entrada, {
                    NumOrdenPromo: ticket[0].NumOrdenPromo,
                    NumeroEntradas: ticket[0].NumTicket
                  });
                  if (ticket[0].OrdenCjta == '0') {
                    if (entrada.NumOrdenPromo == ticket[0].NumOrdenPromo) {
                      if (ticket[0].ImprimirQRPromo == '1' || ticket[0].ImprimirQRPromo == 'True') {
                        promocionEntradas.push(tempObject);
                      } else {
                        if (entrada.TipoEntradaId == ticket[0].TipoProducto) {
                          promocionEntradas.push(tempObject);
                        }
                      }
                    }
                  } else {
                    promocionEntradas.push(tempObject);
                  }
                  //Yaribel 20210224 >>
                });
                //
                const temp = Object.assign({}, datosEntrada, {
                  PromocionEntradas: promocionEntradas
                });
                let numTickets = '';
                for (const [k, item] of Object.entries(ticket)) {
                  numTickets = '' + numTickets + ', ' + item.NumTicket;
                }
                numTickets = numTickets.substr(1);
                //
                let txtMotivo: string = motivos && motivos.length > 0 && motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === ticket[0].ItemId) ?
                  motivos.find(x => x.NumTicket === ticket[0].NumTicket && x.TipoEntradaId === ticket[0].ItemId).ItemNombre : '';
                respuesta.push({
                  tickets: ticket,
                  yaDevuelto: yaDevuelto,
                  id: +ticket[0].NumTicket,
                  numTickets: numTickets,
                  itemInfo: temp,
                  descMotivo: txtMotivo
                });
              }
            }
          }
        }
      }

    } catch (e) {
      this.toast.error(this.translate.instant('ERROR_INESPERADO'), 'Error', {
        toastComponent: ErrorToast
      });
    } finally {
      return respuesta;
    }

  }

// Yaribel 20210224 >>


  groupBy(xs, f) {
    xs = xs || [];
    return xs.reduce(
      (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
      {}
    );
  }

  protected setPage(page: number): void {
    this.arr = this.arr || [];
    this.pager = this.pagerService.getPager(this.arr.length, page, 10);
    this.pagedItems = this.arr.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );

    this.pager.pages = this.pager.pages.filter(
      num => num <= this.pager.totalPages
    );

    while (this.pager.pages.length < 6 && this.pager.pages[0] > 1) {
      this.pager.pages.unshift(this.pager.pages[0] - 1);
    }
  }

  async devolver() {
    this.pulsado = true;
    const pd = this.devolucionService.pagoDesglosadoValue;
    const efectivo = Number(pd?.metalico ?? pd?.efectivo) || 0;
    const centimos = Math.round(efectivo * 100);
    if (this.gestorEfectivoService.isCashManagerConnected() && centimos > 0) {
      const res = await this.gestorEfectivoService.processCashOperation('D', centimos);
      if (!res.ok) {
        this.pulsado = false;
        const rawError = getErrorMessage(res);
        const clave = normalizeCashKeeperError(rawError);
        const traducido = this.translate.instant(clave);
        const desc = extractDescriptionCashKeeper(rawError);
        const msg =
          traducido === clave
            ? desc || this.translate.instant(CASHKEEPER_ERROR_DEFAULT)
            : traducido || this.translate.instant(CASHKEEPER_ERROR_DEFAULT);
        this.toast.error(msg, '', { toastComponent: ErrorToast });
        return;
      }
    }

    const saltar = true;
    let oldNumAlbaran: string = this.albaranService.albaranValue.NumAlbaran;
    let oldAlbaranTPVid: string = this.albaranService.albaranValue.TPVId;
    const condicionIf = !saltar && (this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1'
      || this.albaranService.albaranValue.AlbaranFOPs.length < 2);
    if (condicionIf) {

      if (this.selectedItems.length === this.arr.length) {
        // 
        if (this.albaranService.albaranValue.TienePagoCC === '1') {
          this.albaranService
            .generarIdentificadores(
              this.albaranService.albaranValue.TPVId,
              this.albaranService.albaranValue.Prefijo
            )
            .subscribe((data: any) => {
              /* const res: any = await this.albaranService.anularAlbaranTarjeta(
                data.DatosResult.Identificador,
                data.DatosResult.NumAlbaran
              ); */
              this.albaranService
                .anularAlbaranTarjeta(
                  data.DatosResult.Identificador,
                  data.DatosResult.NumAlbaran
                )
                .pipe(
                  catchError(e => {
                    return of({ success: false, data: null })
                  })
                )
                .subscribe(item => {
                  if (item && item.hasOwnProperty('success') && !item.success) {
                    return;
                  }
                  // 
                  if (item.AlbaranId && item.Facturado === '0') {
                    this.albaranService
                      .refrescarAlbaran(
                        this.albaranService.albaranValue.NumAlbaran
                      )
                      .subscribe(() => {
                        this.albaranService.anulacionTotal.next(false);
                        this.unselectAll();
                        this.router.navigate(['gestionar-venta']).then(() => {
                        }).catch((error) => {
                        });
                      }, (error) => {
                      });

                  } else if (item.AlbaranId && item.Facturado === '1') {
                    // 
                    // this.facturaService
                    //   .recuperarFacturaRelacionAnular(item)
                    //   .pipe(
                    //     mergeMap(res => {
                    //       if (res) {
                    //         const facturas = res.DatosResult.Facturas.map(
                    //           factura => this.facturaService.pdfFactura(factura)
                    //         );
                    //         return forkJoin(facturas);
                    //       }
                    //     })
                    //   )
                    //   .subscribe(async (facturas: any) => {
                    //     if (facturas) {
                    //       for (let i = 0; i < facturas.length; i++) {
                    //         await this.printService.printFacturaPDF(
                    //           facturas[i].DatosResult
                    //         );
                    //       }
                    //       this.albaranService
                    //       .refrescarAlbaran(
                    //         this.albaranService.albaranValue.NumAlbaran
                    //       )
                    //       .subscribe(() => {
                    //         this.albaranService.anulacionTotal.next(false);
                    //         this.unselectAll();
                    //         this.router.navigate(['gestionar-venta']);
                    //       });
                    //     }
                    //   });

                    this.facturaService
                      .pdfFactura(item)
                      .subscribe(async (facturas: any) => {
                        if (facturas.DatosResult) {
                          await this.printService.printFacturaPDF(
                            facturas.DatosResult
                          );
                          this.albaranService
                            .refrescarAlbaran(
                              this.albaranService.albaranValue.NumAlbaran
                            )
                            .subscribe(() => {
                              this.albaranService.anulacionTotal.next(false);
                              this.unselectAll();
                              this.router.navigate(['gestionar-venta']).then(() => {
                              }).catch((error) => {
                              });
                            }, (error) => {
                            });
                        } else {
                        }
                      }, (error) => {
                      });
                  } else {
                  }
                  if (item.NumAlbaran) {
                    this.imprimirJustificanteDevolucion(item.NumAlbaran, 'TOTAL');
                    this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                    }, (error) => {
                    });
                  } else {
                  }

                  // this.albaranService.refrescarAlbaranConTPVId(item.Numalbaran,item.TPVId).subscribe(datos =>{
                  //   if(datos)
                  //   {
                  //       this.printService.printRefundAlbaran({ 
                  //         datos: datos
                  //       });
                  //   }
                  // });


                });
            });
        } else {
          const response: any = await this.albaranService.anularAlbaran();
          if (response.AlbaranId && response.Facturado === '0') {
            this.albaranService
              .refrescarAlbaran(this.albaranService.albaranValue.NumAlbaran)
              .subscribe(() => {
                this.albaranService.anulacionTotal.next(false);
                this.unselectAll();
                this.router.navigate(['gestionar-venta']);
              });
          } else if (response.AlbaranId && response.Facturado === '1') {
            // 
            // this.facturaService
            //   .recuperarFacturaRelacionAnular(response)
            //   .pipe(
            //     mergeMap(resp => {
            //       if (resp) {
            //         const facturas = resp.DatosResult.Facturas.map(factura =>
            //           this.facturaService.pdfFactura(factura)
            //         );
            //         return forkJoin(facturas);
            //       }
            //     })
            //   )
            //   .subscribe(async (facturas: any) => {
            //     if (facturas) {
            //       for (let i = 0; i < facturas.length; i++) {
            //         await this.printService.printFacturaPDF(facturas[i].DatosResult);
            //       }
            //       this.albaranService
            //       .refrescarAlbaran(
            //         this.albaranService.albaranValue.NumAlbaran
            //       )
            //       .subscribe(() => {
            //         this.albaranService.anulacionTotal.next(false);
            //         this.unselectAll();
            //         this.router.navigate(['gestionar-venta']);
            //       });
            //     }
            //   });
            this.facturaService
              .pdfFactura(response)
              .subscribe(async (facturas: any) => {
                if (facturas.DatosResult) {
                  await this.printService.printFacturaPDF(facturas.DatosResult);
                  this.albaranService
                    .refrescarAlbaran(
                      this.albaranService.albaranValue.NumAlbaran
                    )
                    .subscribe(() => {
                      this.albaranService.anulacionTotal.next(false);
                      this.unselectAll();
                      this.router.navigate(['gestionar-venta']);
                    });
                }
              });
          }
          if (response.NumAlbaran) {
            this.imprimirJustificanteDevolucion(response.NumAlbaran, 'TOTAL');
            this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe();
          } else {
          }
        }

      } else {
        if (this.albaranService.albaranValue.TienePagoCC === '1') {
          this.albaranService
            .generarIdentificadores(
              this.albaranService.albaranValue.TPVId,
              this.albaranService.albaranValue.Prefijo
            )
                .subscribe((data: any) => {
              this.albaranService
                .devolucionParcialTarjeta(
                  this.selectedItems,
                  data.DatosResult.Identificador,
                  data.DatosResult.NumAlbaran
                )
                .subscribe((item: any) => {

                  // if (item) {
                  //   this.albaranService
                  //     .datosAlbaran(this.albaranService.albaranValue.NumAlbaran)
                  //     .subscribe(res => {
                  //       if (
                  //         res.DatosResult.ListadoAlbaranInfo[0].Facturado === '1'
                  //       ) {
                  //         this.facturaService
                  //           .recuperarFacturaRelacion(
                  //             this.albaranService.albaranValue
                  //           )
                  //           .pipe(
                  //             mergeMap(res => {
                  //               if (res) {
                  //                 const facturas = res.DatosResult.Facturas.map(
                  //                   factura =>
                  //                     this.facturaService.pdfFactura(factura)
                  //                 );
                  //                 return forkJoin(facturas);
                  //               }
                  //             })
                  //           )
                  //           .subscribe((facturas: any) => {
                  //             if (facturas) {
                  //               for (let i = 0; i < facturas.length; i++) {
                  //                 this.printService.printFacturaPDF(
                  //                   facturas[i].DatosResult
                  //                 );
                  //               }
                  //               this.albaranService
                  //                 .refrescarAlbaran(
                  //                   this.albaranService.albaranValue.NumAlbaran
                  //                 )
                  //                 .subscribe();
                  //               this.albaranService.anulacionTotal.next(false);
                  //               this.unselectAll();
                  //               this.router.navigate(['gestionar-venta']);
                  //             }
                  //           });
                  //       } else {
                  //         this.albaranService
                  //           .refrescarAlbaran(
                  //             this.albaranService.albaranValue.NumAlbaran
                  //           )
                  //           .subscribe();
                  //         this.albaranService.anulacionTotal.next(false);
                  //         this.unselectAll();
                  //         this.router.navigate(['gestionar-venta']);
                  //       }
                  //     });
                  // }

                  if (item.DatosResult) {
                    // Guardar referencia al albarán original para determinar tipo de pago
                    const albaranOriginal = this.albaranService.albaranValue;
                    
                    // Verificar si el pago original fue con tarjeta PINPAD (TieneLectorElectronico === 'True' = PINPAD)
                    const esPagoConPinpad = albaranOriginal?.TienePagoCC === '1' && 
                                           albaranOriginal?.PagoCCInfo?.TieneLectorElectronico === 'True';
                    
                    
                    // Verificar si la devolución generó una factura (FacturaSerie y FacturaNumero presentes)
                    if (item.DatosResult.FacturaSerie && item.DatosResult.FacturaNumero) {
                      // Si es PINPAD, usar GenerarTarjetaPDF en lugar de Factura/GenerarPDF
                      if (esPagoConPinpad) {
                        // Actualizar datosTarjeta con el NumAlbaran de la devolución
                        this.albaranService.refrescarAlbaran(item.DatosResult.NumAlbaran).subscribe(res => {
                          if (res) {
                            if (!this.pagoService.datosTarjeta) {
                              this.pagoService.datosTarjeta = {} as any;
                            }
                            this.pagoService.datosTarjeta.NumAlbaran = item.DatosResult.NumAlbaran;
                            this.pagoService.datosTarjeta.Identificador = this.albaranService.albaranValue.NumVenta || item.DatosResult.NumAlbaran;
                            
                            const tpvId = this.albaranService.albaranValue.TPVId || 'TPV';
                            const numVenta = this.albaranService.albaranValue.NumVenta || item.DatosResult.NumAlbaran;
                            const nombreIdentificador = `${tpvId} - ${numVenta}`;
                            
                            // Llamar a /Justificante/GenerarTarjetaPDF
                            this.pagoService.impresionTarjeta(nombreIdentificador).subscribe(
                              (response) => {
                                // CORRECCIÓN CASO 01: Agregar redirección después de impresión exitosa
                                this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                                  this.albaranService.anulacionTotal.next(false);
                                  this.unselectAll();
                                  this.router.navigate(['gestionar-venta']).then(() => {
                                  }).catch((error) => {
                                  });
                                }, (error) => {
                                });
                              },
                              (error) => {
                                // CORRECCIÓN CASO 01: Redirigir incluso si hay error en la impresión
                                this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                                  this.albaranService.anulacionTotal.next(false);
                                  this.unselectAll();
                                  this.router.navigate(['gestionar-venta']).then(() => {
                                  }).catch((error) => {
                                  });
                                }, (refreshError) => {
                                });
                              }
                            );
                          } else {
                            // CORRECCIÓN: Redirigir incluso si refrescarAlbaran retorna null/undefined
                            this.albaranService.anulacionTotal.next(false);
                            this.unselectAll();
                            this.router.navigate(['gestionar-venta']).then(() => {
                            }).catch((error) => {
                            });
                          }
                        }, (error) => {
                        });
                      } else {
                        this.facturaService.generarPDFFacturaDevolucion(
                          item.DatosResult.FacturaSerie,
                          item.DatosResult.FacturaNumero
                        ).subscribe(() => {
                          this.albaranService
                            .refrescarAlbaran(oldNumAlbaran)
                            .subscribe(() => {
                              this.albaranService.anulacionTotal.next(false);
                              this.unselectAll();
                              this.router.navigate(['gestionar-venta']).then(() => {
                              }).catch((error) => {
                              });
                            }, (error) => {
                            });
                        }, (error) => {
                        });
                      }
                    } else {
                      // CORRECCIÓN: Pasar albarán original y callback de redirección para ejecutar después de la impresión
                      if (esPagoConPinpad) {
                      } else {
                      }
                      this.imprimirJustificanteDevolucion(item.DatosResult.NumAlbaran, 'PARCIAL', albaranOriginal, () => {
                        this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                          this.albaranService.anulacionTotal.next(false);
                          this.unselectAll();
                          this.router.navigate(['gestionar-venta']).then(() => {
                          }).catch((error) => {
                          });
                        }, (error) => {
                        });
                      });
                    }
                  }
                }, (error) => {
                  this.pulsado = false;
                });
            }, (error) => {
              this.pulsado = false;
            });
        } else {
          const res: any = await this.albaranService.devolucionParcial(
            this.selectedItems
          );
          // if (res) {
          //   this.albaranService
          //     .datosAlbaran(this.albaranService.albaranValue.NumAlbaran)
          //     .subscribe(res => {
          //       if (res.DatosResult.ListadoAlbaranInfo[0].Facturado === '1') {
          //         this.facturaService
          //           .recuperarFacturaRelacion(this.albaranService.albaranValue)
          //           .pipe(
          //             mergeMap(res => {
          //               if (res) {
          //                 const facturas = res.DatosResult.Facturas.map(factura =>
          //                   this.facturaService.pdfFactura(factura)
          //                 );
          //                 return forkJoin(facturas);
          //               }
          //             })
          //           )
          //           .subscribe((facturas: any) => {
          //             if (facturas) {
          //               for (let i = 0; i < facturas.length; i++) {
          //                 this.printService.printFacturaPDF(
          //                   facturas[i].DatosResult
          //                 );
          //               }
          //               this.albaranService
          //                 .refrescarAlbaran(
          //                   this.albaranService.albaranValue.NumAlbaran
          //                 )
          //                 .subscribe();
          //               this.albaranService.anulacionTotal.next(false);
          //               this.unselectAll();
          //               this.router.navigate(['gestionar-venta']);
          //             }
          //           });
          //       } else {
          //         this.albaranService
          //           .refrescarAlbaran(this.albaranService.albaranValue.NumAlbaran)
          //           .subscribe();
          //         this.albaranService.anulacionTotal.next(false);
          //         this.unselectAll();
          //         this.router.navigate(['gestionar-venta']);
          //       }
          //     });
          // }

          if (res.DatosResult) {
            // Guardar referencia al albarán original para determinar tipo de pago
            const albaranOriginal = this.albaranService.albaranValue;
            
            // Verificar si el pago original fue con tarjeta PINPAD
            const esPagoConPinpad = albaranOriginal?.TienePagoCC === '1' && 
                                   albaranOriginal?.PagoCCInfo?.TieneLectorElectronico === 'True';
            
            
            // Llamar a GenerarPDF en TODAS las situaciones de devolución
            if (res.DatosResult.FacturaSerie && res.DatosResult.FacturaNumero) {
              // Con factura: si es PINPAD, usar GenerarTarjetaPDF, sino usar Factura/GenerarPDF
              if (esPagoConPinpad) {
                // Actualizar datosTarjeta con el NumAlbaran de la devolución
                this.albaranService.refrescarAlbaran(res.DatosResult.NumAlbaran).subscribe(refreshRes => {
                  if (refreshRes) {
                    if (!this.pagoService.datosTarjeta) {
                      this.pagoService.datosTarjeta = {} as any;
                    }
                    this.pagoService.datosTarjeta.NumAlbaran = res.DatosResult.NumAlbaran;
                    this.pagoService.datosTarjeta.Identificador = this.albaranService.albaranValue.NumVenta || res.DatosResult.NumAlbaran;
                    
                    const tpvId = this.albaranService.albaranValue.TPVId || 'TPV';
                    const numVenta = this.albaranService.albaranValue.NumVenta || res.DatosResult.NumAlbaran;
                    const nombreIdentificador = `${tpvId} - ${numVenta}`;
                    
                    // Llamar a GenerarTarjetaPDF
                    this.pagoService.impresionTarjeta(nombreIdentificador).subscribe(
                      (response) => {
                        this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                          this.albaranService.anulacionTotal.next(false);
                          this.unselectAll();
                          this.router.navigate(['gestionar-venta']);
                        });
                      },
                      (error) => {
                        this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                          this.albaranService.anulacionTotal.next(false);
                          this.unselectAll();
                          this.router.navigate(['gestionar-venta']);
                        });
                      }
                    );
                  }
                });
              } else {
                // Con factura pero NO es PINPAD: usar Factura/GenerarPDF
                this.facturaService.generarPDFFacturaDevolucion(
                  res.DatosResult.FacturaSerie,
                  res.DatosResult.FacturaNumero
                ).subscribe(() => {
                  this.albaranService
                    .refrescarAlbaran(oldNumAlbaran)
                    .subscribe();
                  this.albaranService.anulacionTotal.next(false);
                  this.unselectAll();
                  this.router.navigate(['gestionar-venta']).then(() => {
                  }).catch((error) => {
                  });
                });
              }
            } else {
                // Sin factura: si es PINPAD, usar GenerarTarjetaPDF, sino usar justificante
                if (esPagoConPinpad) {
                  this.imprimirJustificanteDevolucion(res.DatosResult.NumAlbaran, 'PARCIAL', albaranOriginal, () => {
                    this.albaranService.refrescarAlbaran(oldNumAlbaran).subscribe(() => {
                      this.albaranService.anulacionTotal.next(false);
                      this.unselectAll();
                      this.router.navigate(['gestionar-venta']).then(() => {
                      }).catch((error) => {
                      });
                    });
                  });
                } else {
                  // Sin factura y NO es PINPAD: usar endpoint de justificante (como anulación)
                  this.facturaService.generarPDFJustificanteDevolucion(
                    res.DatosResult.NumAlbaran
                  ).subscribe(() => {
                    this.albaranService
                      .refrescarAlbaran(oldNumAlbaran)
                      .subscribe();
                    this.albaranService.anulacionTotal.next(false);
                    this.unselectAll();
                    this.router.navigate(['gestionar-venta']).then(() => {
                    }).catch((error) => {
                    });
                  });
                }
            }
          } else {
          }
        }
      }
    } else {
      // Pago multiple nueva ventana - Navegar directamente a pago-devolucion-parcial
      // Verificar configuración de motivos de devolución
      this.verificarConfiguracionMotivosDevolucion();
    }
  }

  /**
   * Verifica la configuración de motivos de devolución y decide si mostrar el modal o navegar directamente
   * 🔧 TEMPORAL: Forzando modal para pruebas
   */
  private verificarConfiguracionMotivosDevolucion() {
    
    // Obtener configuración de motivos de devolución
    const motivosConfig = this.conf?.DatosResult?.AppConfigJsonConfig?.MotivosDevolucion;
    
    // Si no existe la configuración, considerar como Solicitar=0
    const solicitarMotivo = motivosConfig?.Solicitar === '1';
    const esObligatorio = motivosConfig?.Obligatorio === '1';
    
    
    if (solicitarMotivo) {
      // Abrir modal de motivos de devolución
      const modal = this.modalService.get('modal-motivos-devolucion');
      if (modal) {
        modal.open(esObligatorio, () => {
          this.router.navigate(['/gestionar-venta/pago-devolucion-parcial']);
        });
      } else {
        this.pulsado = false;
        this.toast.error('Error al abrir modal de motivos', 'Error', {
          toastComponent: ErrorToast,
          timeOut: 5000,
        });
      }
    } else {
      // Navegar directamente a pago-devolucion-parcial (comportamiento actual)
      this.router.navigate(['/gestionar-venta/pago-devolucion-parcial']);
    }
  }

  ngOnDestroy() {

    const saltar = true;
    if (!saltar && (this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1'
      || this.albaranService.albaranValue.AlbaranFOPs.length < 2)) {
      this.unselectAll();
      this.albaranService.anulacionTotal.next(false);
    } else {
      this.devolucionService.setItemsSeleccionados(this.selectedItems);
      this.devolucionService.setCarritoDevolucion(this.devolucionService.carritoDevolucion);
      this.selectedItems = [];
    }
  }

  focusValue(event: Event) {
    const target = event.target as HTMLInputElement;
    const category = target.getAttribute('category');
    
    this.formControlService.setCurrentFormGroup(
      this.busquedaForm,
      target,
      category
    );
  }

  getFechaSeleccionada() {
    /*if (this.albaranService.) {
      return moment(this.ventaService.fechaSeleccionadaValue)
        .locale(this.idioma)
        .format('L');
    }*/
  }

  claseSeleccionaSesion(sesion) {
    let seleccionada = false;
    // 
    if (this.sesionesSeleccionadas.length > 0) {
      // 
      this.sesionesSeleccionadas.forEach(sesionSeleccionada => {
        if (sesionSeleccionada.FechaEntrada == sesion.FechaEntrada &&
          sesion.RecintoId == sesionSeleccionada.RecintoId) {
          seleccionada = true;
        }
      });
    }
    if (seleccionada) {
      return 'Rtable-cell--content horario-content selected';
    } else {
      return 'Rtable-cell--content horario-content';
    }
  }

  seleccionarSesion(sesion) {
    // 
    this.sesionesSeleccionadas.push(sesion);
  }

  prev() {
    if (this.comprobarLimitePrev()) {
      return;
    }
    this.currentRecintoIndex--;
    this.currentRecinto = this.recintos[this.currentRecintoIndex];
    //this.ventaService.currentRecinto = this.recintos[this.currentRecintoIndex];
  }

  comprobarLimitePrev() {
    return this.currentRecintoIndex === 0;
  }

  next() {
    if (this.comprobarLimiteNext()) {
      //this.navigationService.next();
      return;
    }
    this.currentRecintoIndex++;
    this.currentRecinto = this.recintos[this.currentRecintoIndex];
    //this.ventaService.currentRecinto = this.recintos[this.currentRecintoIndex];
  }

  comprobarLimiteNext() {
    return this.currentRecintoIndex === this.recintos.length - 1;
  }

  isSelected(sesion) {
    /*
     
     /*return this.ventaService.carritoValue.horarios.find(
       horario =>
         (horario.sesion.RecintosSesionId === sesion.RecintosSesionId ||
           (!horario.sesion.RecintosSesionId && sesion.RecintoId == horario.sesion.RecintoId)) &&
         horario.sesion.Fecha === sesion.Fecha &&
         horario.sesion.HoraInicio === sesion.HoraInicio
     );*/
  }


  imprimirJustificanteDevolucion(NumAlbaran: string, tipo: string, albaranOriginal?: any, onComplete?: () => void) {
    // Guardar referencia al albarán original para verificar tipo de pago
    const albaranOrigen = albaranOriginal || this.albaranService.albaranValue;
    
    // Verificar si el pago original fue con tarjeta PINPAD (no DATAFONO)
    // Según el código: TieneLectorElectronico === 'True' = PINPAD, TieneLectorElectronico === 'False' = DATAFONO
    const esPagoConPinpad = albaranOrigen?.TienePagoCC === '1' && 
                           albaranOrigen?.PagoCCInfo?.TieneLectorElectronico === 'True';
    
    // Si es pago con PINPAD, llamar a GenerarTarjetaPDF
    if (esPagoConPinpad) {
      // Actualizar datosTarjeta con el NumAlbaran de la devolución antes de llamar a impresionTarjeta
      this.albaranService.refrescarAlbaran(NumAlbaran).subscribe(res => {
        if (res) {
          // Actualizar datosTarjeta con el NumAlbaran del albarán de devolución
          if (!this.pagoService.datosTarjeta) {
            this.pagoService.datosTarjeta = {} as any;
          }
          this.pagoService.datosTarjeta.NumAlbaran = NumAlbaran;
          this.pagoService.datosTarjeta.Identificador = this.albaranService.albaranValue.NumVenta || NumAlbaran;
          
          const tpvId = this.albaranService.albaranValue.TPVId || 'TPV';
          const numVenta = this.albaranService.albaranValue.NumVenta || NumAlbaran;
          const nombreIdentificador = `${tpvId} - ${numVenta}`;
          
          // Llamar a GenerarTarjetaPDF para imprimir el justificante de devolución con tarjeta
          // Esto llama a /api/Justificante/GenerarTarjetaPDF
          this.pagoService.impresionTarjeta(nombreIdentificador).subscribe(
            (response) => {
              // CORRECCIÓN CASO 01: Ejecutar callback de redirección después de impresión exitosa
              if (onComplete) {
                onComplete();
              }
            },
            (error) => {
              // CORRECCIÓN CASO 01: Ejecutar callback de redirección incluso si hay error en la impresión
              if (onComplete) {
                onComplete();
              }
            }
          );
        } else {
          // Si refrescarAlbaran retorna null/undefined, ejecutar callback de todas formas
          if (onComplete) {
            onComplete();
          }
        }
      }, (error) => {
        // Ejecutar callback incluso si refrescarAlbaran falla
        if (onComplete) {
          onComplete();
        }
      });
      return;
    }
    
    // Si es DATAFONO, no hacer nada (el datáfono imprime por sí mismo)
    if (albaranOrigen?.TienePagoCC === '1' && 
        albaranOrigen?.PagoCCInfo?.TieneLectorElectronico === 'False') {
      // Ejecutar callback inmediatamente ya que no hay impresión que esperar
      if (onComplete) {
        onComplete();
      }
      return;
    }
    
    // Para pago metálico u otros, usar el método normal de impresión
    this.pagoService.impresionJustificante(
      NumAlbaran,
      `${albaranOrigen?.TPVId || 'TPV'} - ${albaranOrigen?.NumVenta || NumAlbaran}`
    ).subscribe(
      (response) => {
        // Ejecutar callback después de la impresión
        if (onComplete) {
          onComplete();
        }
      },
      (error) => {
        // Ejecutar callback incluso si hay error
        if (onComplete) {
          onComplete();
        }
      }
    );
  }
}
